import { UserOrRoleDc } from "@evergis/api";
import { AccessRoleGroup } from "./types";

export function getAclRole(roleName: string, users: UserOrRoleDc[] = []) {
  const aclRole = users.find(({ name }) => roleName === name)?.aclRole;

  return aclRole || (roleName !== AccessRoleGroup.Public ? `__${roleName}` : "__public");
}

export function getNameByRole(aclRoleName: string, users: UserOrRoleDc[] = []) {
  const name = users.find(({ aclRole }) => aclRoleName === aclRole)?.name;

  return name || (aclRoleName?.startsWith("__") ? aclRoleName.slice(2, aclRoleName.length) : aclRoleName);
}
